import React, { Component } from 'react';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getList } from '../../controlador_erro_geral/erroGeralActions';
import { saveNotificationsToLocalStorage } from '../../controlador_erro/erroActions';
import TicketSuporteForm from '../../ticket_suporte/ticketSuporteForm';

// CSS customizado para o modal
const modalStyles = `
  .custom-modal-width {
    max-width: 70vw !important;
    width: 70vw !important;
  }
  
  @media (max-width: 768px) {
    .custom-modal-width {
      max-width: 95vw !important;
      width: 95vw !important;
    }
  }
`;

// Adiciona o CSS ao head se ainda não existir
if (!document.getElementById('notification-modal-styles')) {
  const style = document.createElement('style');
  style.id = 'notification-modal-styles';
  style.textContent = modalStyles;
  document.head.appendChild(style);
}

class NotificationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificacoesSelecionadas: [],
      showTicketModal: false,
      selectedNotificationForTicket: null,
    };

    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
  }

  handleSelectAll = () => {
    const { notifications } = this.props;
    const sortedNotifications = [...notifications].sort((a, b) => {
      const dateA = new Date(a.data_erro + 'T' + a.hora_erro);
      const dateB = new Date(b.data_erro + 'T' + b.hora_erro);
      return dateB - dateA;
    });
    const allSelected = this.state.notificacoesSelecionadas.length === sortedNotifications.length;

    if (allSelected) {
      this.setState({ notificacoesSelecionadas: [] });
    } else {
      const allIds = sortedNotifications.map((_, index) => index.toString());
      this.setState({ notificacoesSelecionadas: allIds });
    }
  };

  handleShowTicketModal(notification) {
    this.setState({ showTicketModal: true, selectedNotificationForTicket: notification });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedNotificationForTicket: null });
  }

  handleOnChange = event => {
    const notificacoesSelecionadas = [...this.state.notificacoesSelecionadas];
    const id = event.target.id;

    if (!notificacoesSelecionadas.includes(id)) {
      notificacoesSelecionadas.push(id);
    } else {
      const index = notificacoesSelecionadas.indexOf(id);
      notificacoesSelecionadas.splice(index, 1);
    }
    this.setState({ notificacoesSelecionadas });
  };

  mensagensSelecionadasLida = () => {
    const { notifications, clearAlertaErro, getList } = this.props;

    // A lista precisa ser ordenada da mesma forma que no render() para que os índices coincidam.
    const sortedNotifications = [...notifications].sort((a, b) => {
      const dateA = new Date(a.data_erro + 'T' + a.hora_erro);
      const dateB = new Date(b.data_erro + 'T' + b.hora_erro);
      return dateB - dateA;
    });

    this.state.notificacoesSelecionadas.forEach(index => {
      // Usa a lista ordenada para pegar a notificação correta.
      const notification = sortedNotifications[index];
      if (notification) {
        clearAlertaErro(notification, false);
      }
    });

    this.setState({ notificacoesSelecionadas: [] });
    getList(0, [], []);

    toastr.success('Sucesso', 'As mensagens selecionadas foram marcadas como lidas.', {
      position: 'bottom-right',
    });
  };

  render() {
    const { showModal, handleCloseModal, notifications, clearAlertaErro, handleTodasMensagensLidas } = this.props;

    // Ordenar notificações por data e hora (mais recentes primeiro)
    const sortedNotifications = [...notifications].sort((a, b) => {
      const dateA = new Date(a.data_erro + 'T' + a.hora_erro);
      const dateB = new Date(b.data_erro + 'T' + b.hora_erro);
      return dateB - dateA;
    });

    const { selectedNotificationForTicket } = this.state;
    let initialTicketData = null;
    if (selectedNotificationForTicket) {
      initialTicketData = {
        titulo: `Erro no Controlador ${selectedNotificationForTicket.numero_controlador}`,
        descricao: `Mensagem de Erro: ${selectedNotificationForTicket.mensagem}\n\nDetalhes:\n- Data: ${moment(
          selectedNotificationForTicket.data_erro,
        ).format('DD/MM/YYYY')}\n- Hora: ${selectedNotificationForTicket.hora_erro}\n- Controlador: ${
          selectedNotificationForTicket.numero_controlador
        }\n- Grupo Físico: ${selectedNotificationForTicket.grupo_fisico_id}`,
        grupo_fisico_id: selectedNotificationForTicket.grupo_fisico_id,
        numero_controlador: selectedNotificationForTicket.numero_controlador,
        controlador_erro_id: selectedNotificationForTicket.id_erro || selectedNotificationForTicket.id, // Compatibilidade
        isFromError: true,
        controlador_id: '',
      };
    }

    return (
      <>
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          aria-labelledby="notificationModalLabel"
          centered
          className="rounded shadow"
          dialogClassName="custom-modal-width"
        >
          <Modal.Header closeButton className="bg-primary text-white">
            {notifications.length > 0 && (
              <Modal.Title id="notificationModalLabel">
                {notifications.length > 1
                  ? notifications.length + ' Notificações'
                  : notifications.length + ' Notificação'}
              </Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body style={{ overflowY: 'auto', maxHeight: '600px' }}>
            {notifications.length === 0 ? (
              <h3 style={{ textAlign: 'center' }}>Não há notificações!</h3>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: '3%' }}>
                          <input
                            type="checkbox"
                            onChange={this.handleSelectAll}
                            checked={
                              sortedNotifications.length > 0 &&
                              this.state.notificacoesSelecionadas.length === sortedNotifications.length
                            }
                          />
                        </th>
                        <th style={{ width: '8%' }}>Grupo</th>
                        <th style={{ width: '12%' }}>Controlador</th>
                        <th style={{ width: '10%' }}>Data</th>
                        <th style={{ width: '8%' }}>Hora</th>
                        <th style={{ width: '50%' }}>Mensagem</th>
                        <th style={{ width: '9%' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sortedNotifications.map((notification, index) => (
                        <tr
                          key={
                            notification._timestamp ||
                            `${notification.controlador_id}-${notification.data_erro}-${index}`
                          }
                        >
                          <td>
                            <input
                              type="checkbox"
                              id={index}
                              checked={this.state.notificacoesSelecionadas.includes(index.toString())}
                              onChange={this.handleOnChange}
                            />
                          </td>
                          <td>{notification.grupo_fisico_id || 'N/A'}</td>
                          <td>{notification.numero_controlador || notification.controlador_id}</td>
                          <td>{moment(notification.data_erro).format('DD/MM/YYYY')}</td>
                          <td>{moment(notification.hora_erro, 'HH:mm:ss').format('HH:mm')}</td>
                          <td>{notification.mensagem}</td>
                          <td>
                            <Button
                              variant="link"
                              onClick={() => {
                                clearAlertaErro(notification, true);
                              }}
                              style={{
                                background: 'none',
                                border: 'none',
                                padding: '0',
                                color: '#28a745',
                                cursor: 'pointer',
                              }}
                              title="Marcar como lida"
                            >
                              <i className="fa fa-check" />
                            </Button>
                            <Button
                              variant="link"
                              onClick={() => this.handleShowTicketModal(notification)}
                              style={{
                                background: 'none',
                                border: 'none',
                                padding: '0',
                                color: '#ffc107',
                                cursor: 'pointer',
                                marginLeft: '10px',
                              }}
                              title="Abrir Ticket"
                            >
                              <i className="fa fa-exclamation-triangle" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={
                this.state.notificacoesSelecionadas.length > 0
                  ? this.mensagensSelecionadasLida
                  : handleTodasMensagensLidas
              }
            >
              {this.state.notificacoesSelecionadas.length > 0 ? 'Marcar como Lida' : 'Marcar todas como Lida'}
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {this.state.showTicketModal && (
          <TicketSuporteForm
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={initialTicketData}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = state => ({ user: state.auth.user });
const mapDispatchToProps = dispatch => bindActionCreators({ getList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationModal);
